(() => {
  const sections = document.querySelectorAll("[data-k-osmo]");
  if (!sections.length) return;

  const prefersReduced = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

  sections.forEach((section) => {
    const vids = section.querySelectorAll("video.k-osmo__video");
    if (!vids.length) return;

    const playAll = () => {
      if (prefersReduced) return;
      vids.forEach((v) => {
        try {
          v.muted = true;
          v.playsInline = true;
          const p = v.play();
          if (p && typeof p.catch === "function") p.catch(() => {});
        } catch {}
      });
    };

    const pauseAll = () => {
      vids.forEach((v) => {
        try { v.pause(); } catch {}
      });
    };

    // pause when not visible (perf + battery)
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) playAll();
          else pauseAll();
        });
      },
      { threshold: 0.05 }
    );

    io.observe(section);
  });
})();
